import { useState } from 'react';

interface TopBarProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function TopBar({ title, subtitle, actions }: TopBarProps) {
  const [showNotifications, setShowNotifications] = useState(false);

  return (
    <div className="bg-white border-b border-gray-200 px-8 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="text-sm text-gray-500 mt-1">{subtitle}</p>}
        </div>
        
        <div className="flex items-center space-x-4">
          {actions}
          
          <div className="relative">
            <button 
              onClick={() => setShowNotifications(!showNotifications)}
              className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-600 cursor-pointer relative"
            >
              <i className="ri-notification-3-line text-xl"></i>
              <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>
            
            {showNotifications && (
              <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
                <div className="p-4 border-b border-gray-200">
                  <h3 className="font-semibold text-gray-900">Notificações</h3>
                </div>
                <div className="max-h-96 overflow-y-auto">
                  <div className="p-4 hover:bg-gray-50 border-b border-gray-100 cursor-pointer">
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-gray-900">Nova ordem de serviço criada</p>
                        <p className="text-xs text-gray-500 mt-1">Manutenção preventiva - Bomba Hidráulica #001</p>
                        <p className="text-xs text-gray-400 mt-1">Há 5 minutos</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 hover:bg-gray-50 border-b border-gray-100 cursor-pointer">
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mt-2"></div>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-gray-900">Manutenção vencida</p>
                        <p className="text-xs text-gray-500 mt-1">Compressor de Ar #003 - Venceu há 2 dias</p>
                        <p className="text-xs text-gray-400 mt-1">Há 1 hora</p>
                      </div>
                    </div>
                  </div>
                  <div className="p-4 hover:bg-gray-50 cursor-pointer">
                    <div className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-green-500 rounded-full mt-2"></div>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-gray-900">Ordem concluída</p>
                        <p className="text-xs text-gray-500 mt-1">Troca de óleo - Motor Elétrico #005</p>
                        <p className="text-xs text-gray-400 mt-1">Há 3 horas</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="p-3 border-t border-gray-200 text-center">
                  <button className="text-sm text-blue-600 hover:text-blue-700 font-medium cursor-pointer">
                    Ver todas as notificações
                  </button>
                </div>
              </div>
            )}
          </div>
          
          <button className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-600 cursor-pointer">
            <i className="ri-settings-3-line text-xl"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
